// Redeem-rate fallback for items with no manual points value (a per-item value
// always wins). Mirrors backend lib/points/redeem_rate.go: round the price up to
// the nearest dollar, multiply by the rate. Returns undefined (not 0) when not
// redeemable, so "no rate configured" stays distinct from a real value.
export function effectivePoints(
  priceCents: number,
  ratePerDollar: number | undefined
): number | undefined {
  if (ratePerDollar === undefined || ratePerDollar <= 0 || priceCents <= 0) {
    return undefined;
  }
  return Math.ceil(priceCents / 100) * ratePerDollar;
}
